module.exports = __webpack_public_path__ + "media/images/bet__wrongMarker@2x-6448315f0297b23c91c11fa36909e4db.png";